import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "../styles";
import {
  AgendamentoGroup,
  IAgendamento,
} from "../../../../pages/easyReport/agendamento";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import { notifyOnPage } from "../../../../utils/notifyOnPage";

const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface AddReportModalProps {
  openAddReportModal: boolean;
  setOpenAddReportModal: (open: boolean) => void;
  relatorios: IAgendamento[];
  selectedGroup: AgendamentoGroup | null;
  setGroups: React.Dispatch<React.SetStateAction<AgendamentoGroup[]>>;
  allGroups: AgendamentoGroup[];
}

export default function AddReportModal({
  openAddReportModal,
  setOpenAddReportModal,
  selectedGroup,
  relatorios,
  allGroups,
  setGroups,
}: AddReportModalProps) {
  const [selected, setSelected] = useState<IAgendamento[]>([]);

  useEffect(() => {
    if (selectedGroup) {
      const selectedRelatorios = allGroups
        .filter((group) => group.id === selectedGroup.id)
        .flatMap((group) => group.relatorios);

      setSelected(selectedRelatorios);
    }
  }, [selectedGroup, allGroups]);

  const handleSave = async () => {
    if (!selected) return;

    try {
      const response = await api.post("/easyReport/v2/addReportsInGroup", {
        groupId: selectedGroup?.id,
        reportIds: selected.map((a) => a.id),
      });
      if (response.data.status === "Error") {
        notifyOnPage(
          window.location.pathname,
          "Erro ao adicionar agendamento no grupo!",
          "error",
          3000
        );
      } else {
        if (response.data) {
          notifyOnPage(
            window.location.pathname,
            "Agendamento adicionado ao grupo com sucesso!",
            "success",
            3000
          );
          setGroups((prevGrupos) =>
            prevGrupos.map((g) =>
              g.id === response.data.id ? response.data : g
            )
          );
        }
      }
    } catch (error: any) {
      console.error(error);
      notifyOnPage(
        window.location.pathname,
        error?.response?.data?.error ||
          "Erro ao adicionar agendamento no grupo!",
        "error",
        3000
      );
    }
    setOpenAddReportModal(false);
  };

  return (
    <Dialog
      open={openAddReportModal}
      onClose={() => {
        setOpenAddReportModal(false);
      }}
    >
      <DialogTitle color="primary">
        Adicionar agendamento
        <IconButton
          aria-label="Fechar"
          onClick={() => {
            setOpenAddReportModal(false);
          }}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.text.secondary,
          })}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent}>
        <Typography>Adicionar agendamentos já existentes</Typography>
        <Autocomplete
          multiple
          size="small"
          id="add-schedules-to-group"
          options={relatorios}
          disableCloseOnSelect
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.titulo}
          value={selected}
          onChange={(_, value) => {
            return setSelected(value);
          }}
          renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;

            return (
              <li key={key} {...optionProps}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.titulo}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={styles.textfield}
              placeholder="Selecione os agendamentos"
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button
          sx={styles.buttonCancelDialog}
          onClick={() => {
            setOpenAddReportModal(false);
          }}
        >
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleSave}>
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
